<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="search">
        <a-form layout="horizontal" :model="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="日期" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
                <a-month-picker v-model="form.date" :default-value="moment(new Date(), 'YYYY-MM')" format="YYYY-MM"
                  placeholder="请选择日期" @change="changeDate" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-button type="primary" @click="search()">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
          <a-row style="text-align: left">
            <a-button type="primary" @click="printJson"><span class="iconfont icon-print"></span><span
                style="margin-left: 5px">打印</span></a-button>
            <a-button style="margin-left: 10px" type="default" @click="export2Excel">
              导出excel</a-button>
          </a-row>
          <a-row class="oilCss" v-if="begin!=='' && end!==''">
            <span>期初:{{begin}} 升</span>
            <span>期末:{{end}} 升</span>
          </a-row>
        </a-form>
      </div>
      <div class="table" style="margin-top: 10px">
        <standard-table :columns="columns" :dataSource="listData" :loading="loading" :key="tableKey" 
          bordered>
        </standard-table>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import StandardTable from "@/components/StandardTable";
import { oil_list } from "@/api/modules/summaryManagement.js";
import printJS from "print-js";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  name: "oilStorageManagement",
  data() {
    return {
      spinning: false,
      loading: false,
      tableKey: 0,
      listData: [],
      listDataExcel: null,
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      form: {
        date: this.$moment(new Date()).format("YYYY-MM"),
      },
      columns: [
        {
          title: "日期",
          dataIndex: "date",
          align: "center",
          sortDirections: ["ascend", "descend"],
          defaultSortOrder: "ascend",
          sorter: (a, b) => {
            return (
              Date.parse(a.date.replace(/-/g, "/")) -
              Date.parse(b.date.replace(/-/g, "/"))
            );
          },
          render: (value, record) => {
            return (
              <div>
                <Space>{record.date}</Space>
              </div>
            );
          },
        },
        {
          title: "车号",
          dataIndex: "licenseNum",
          align: "center",
        },
        {
          title: "类型",
          dataIndex: "type",
          align: "center",
        },
        {
          title: "柴油入库（升）",
          dataIndex: "oilIn",
          align: "center",
        },
        {
          title: "柴油出库（升）",
          dataIndex: "oilOut",
          align: "center",
        },
        {
          title: "剩余库存",
          dataIndex: "remain",
          align: "center",
        },
      ],
      begin:'',
      end:''
    };
  },
  components: {
    StandardTable,
  },
  created() {
    this.search();
  },
  methods: {
    moment,
    search() {
      if (!this.form.date) {
        return this.$message.warn("日期不能为空");
      }
      let params = {
        date: this.form.date,
      };
      this.loading = true;
      oil_list(params).then((res) => {
        this.loading = false;
        this.tableKey++;
        if (res.code == "0000") {
          this.begin = res.data.begin
          this.end = res.data.end
          this.listData = res.data.oilSummaryEntities.map((item) => {
            for (let key in item) {
              if (["oilIn", "oilOut", "remain"].some((ele) => ele == key)) {
                if (
                  item.oilIn != null ||
                  item.oilIn != "" ||
                  item.oilIn != undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
                if (
                  item.oilOut !== null ||
                  item.oilOut !== "" ||
                  item.oilOut !== undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
                if (
                  item.remain !== null ||
                  item.remain !== "" ||
                  item.remain !== undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
              }
              if (key !== "remain") {
                if (item[key] == "" || item[key] == null || item[key] == 0.0) {
                  item[key] = "--";
                }
              }
              if (key == "remain") {
                if (item["remain"] == "" || item["remain"] == null || item["remain"] == 0.0) {
                  item[key] = "0.00";
                }
              }
            }
            return item;
          });
          this.pagination.total = res.data.totalCount;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    changeDate(val) {
      if (val == null || val == undefined || val == "") {
        return (this.form.date = "");
      }
      this.form.date = this.$moment(val).format("YYYY-MM-DD");
    },
    reset() {
      this.form.date = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    //表格数据打印
    printJson() {
      let data = [];
      for (let i = 0; i < this.listData.length; i++) {
        data.push({
          field1: this.listData[i].date,
          field2: this.listData[i].licenseNum,
          field3: this.listData[i].type,
          field4: this.listData[i].oilIn,
          field5: this.listData[i].oilOut,
          field6: this.listData[i].remain,
        });
      }
      console.log(data);
      printJS({
        printable: data,
        properties: [
          {
            field: "field1",
            displayName: "日期",
            columnSize: "10%",
            align: "center",
          },
          {
            field: "field2",
            displayName: "车号",
            columnSize: 1,
          },
          {
            field: "field3",
            displayName: "类型",
            columnSize: 1,
          },
          {
            field: "field4",
            displayName: "柴油入库（升）",
            columnSize: 1,
          },
          {
            field: "field5",
            displayName: "柴油出库（升）",
            columnSize: 1,
          },
          {
            field: "field6",
            displayName: "剩余库存",
            columnSize: 1,
          },
        ],
        type: "json",
        header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>柴油库存表</h3> 
                    </div>`,
        // 样式设置
        gridStyle: "border: 1px solid #e8e8e8;text-align:center",
        gridHeaderStyle: "color: #999;  border: 1px solid #ccc;",
      });
    },
    async export2Excel() {
      let params = {
        date: this.form.date,
      };
      await oil_list(params).then((res) => {
        if (res.code == "0000") {
          this.listDataExcel = res.data.oilSummaryEntities.map((item) => {
            for (let key in item) {
              if (["oilIn", "oilOut", "remain"].some((ele) => ele == key)) {
                if (
                  item.oilIn != null ||
                  item.oilIn != "" ||
                  item.oilIn != undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
                if (
                  item.oilOut !== null ||
                  item.oilOut !== "" ||
                  item.oilOut !== undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
                if (
                  item.remain !== null ||
                  item.remain !== "" ||
                  item.remain !== undefined
                ) {
                  item[key] = Number(item[key]).toFixed(2);
                }
              }
              if (item[key] == "" || item[key] == null || item[key] == 0.0) {
                item[key] = "--";
              }
            }
            return item;
          });
        } else {
          this.$message.warn(res.msg);
        }
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../excel/Export2Excel");
        const tHeader = [
          "日期",
          "柴油入库（吨）",
          "柴油出库（升）",
          "车号",
          "类型",
          "剩余库存",
        ];
        const filterVal = [
          "date",
          "oilIn",
          "oilOut",
          "licenseNum",
          "type",
          "remain",
        ];
        const data = this.formatJson(filterVal, this.listDataExcel);
        export_json_to_excel(tHeader, data, "柴油库存表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    onChange(val) {
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
  },
};
</script>

<style lang="less" scoped>
.space {
  display: inline-block;
  margin: 0 5px;
}

.ant-form-item-label {
  width: 100px;
}

.ant-calendar-picker {
  width: 100%;
}
.oilCss{
  width: 300px;
  float: right;
  display: flex;
  justify-content: space-around;
  background-color: aliceblue;
  font-size: 16px;
  font-weight: bold;
}
</style>
